import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useAuth } from "../contexts/authContext";
import PublicRoutes from "./publicRoutes";
import PrivateRoutes from "./privateRoutes";

/**
 * A higher-order component that provides the authentication context to its children.
 * It handles the loading state and ensures that the children are only rendered once the authentication status is known.
 */
const AuthConsumer = ({ children }) => {
  const { loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return children({ loading });
};

/**
 * The main routes component that sets up the router and renders public and private routes.
 * It uses the AuthConsumer to handle the loading state and ensure routes are only rendered once the authentication status is known.
 */
const AppRoutes = () => (
  <Router>
    <Routes>
      {PublicRoutes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element}>
          {route.children &&
            route.children.map((child, childIndex) => (
              <Route
                key={childIndex}
                path={child.path}
                element={child.element}
              />
            ))}
        </Route>
      ))}
      {PrivateRoutes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element}>
          {route.children &&
            route.children.map((child, childIndex) => (
              <Route
                key={childIndex}
                path={child.path}
                element={child.element}
              />
            ))}
        </Route>
      ))}
    </Routes>
  </Router>
);

export { AppRoutes, AuthConsumer };
